module.exports = __webpack_public_path__ + "static/media/androidColoredIcon.ec6f0c8f.svg";